<template>
	<CombinedPage label="stats" :routes="routes" />
</template>

<script>
import CombinedPage from '@/components/common/CombinedPage';
import { useStatsRoutes } from '@/components/top_level/navigationConsts/statsRoutes';

export default {
	components: {
		CombinedPage,
	},
	setup() {
		return {
			routes: useStatsRoutes(),
		};
	},
}
</script>
